import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Pagetitle from '../../component/PageTitle';
import BlogServices from '../../services/BlogServices';

const AddNew = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // For editing mode if an id is provided

  const [formValues, setFormValues] = useState({
    title: '',
    author: '',
    content: '',
    images: '',
    status: 'Active',
  });
  // const [previewImage, setPreviewImage] = useState('img/placeholder-img.png');

  const [errorMessage, setErrorMessage] = useState('');
  const [previewImages, setPreviewImages] = useState([]);



  // Handle form input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    setFormValues({
      ...formValues,
      images: files,
    });

    const previewFiles = files.map((file) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      return new Promise((resolve) => {
        reader.onloadend = () => {
          resolve(reader.result);
        };
      });
    });

    Promise.all(previewFiles).then((images) => {
      setPreviewImages(images);
    });
  };
  
  const handleSubmit = async (event) => {
    event.preventDefault();
  
    try {
      const formData = new FormData();
  
      // Append form values to formData, including the image file
      formData.append('title', formValues.title);
      formData.append('author', formValues.author);
      formData.append('content', formValues.content);

  
      // Append each image file separately
      formValues.images.forEach((image) => {
        formData.append('images', image);
      });
  
      // Submit the form data
      const response = await BlogServices.createBlog(formData); // Pass formData
      setPreviewImages(['img/placeholder-img.png']);
      // console.log(response);
      alert('Blog Added Successfully');
      navigate('/admin/blog');

    } catch (error) {
      console.error('Failed to Blog details', error);
      alert('Failed to add Blog details');
    }
  };

  return (
    <>
      <div className="right_col" role="main">
        <Pagetitle />
        <div className="container-box">
          <div className="container-box-top-header justify-content-end">
            {/* "List Blogs" button to navigate to Blog.js page */}
            <div className="sub-title-box-right">
              <Link className="site-btn-green" to="/admin/blog">
               Blogs List
              </Link>
            </div>
          </div>
          <div className="container-box-inner px-4">
            <div className="page-details">
              <form onSubmit={handleSubmit} >
                <div className="row">
                  <div className="col-lg-4 col-md-6">
                    <div className="input-field">
                      <label>Title*</label>
                      <input
                        type="text"
                        name="title"
                        value={formValues.title}
                        onChange={handleInputChange}
                        placeholder="Enter Title"
                        className="form-control"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="input-field">
                      <label>Author*</label>
                      <input
                        type="text"
                        name="author"
                        value={formValues.author}
                        onChange={handleInputChange}
                        placeholder="Enter Author Name"
                        className="form-control"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-sm-12">
                  <div className="input-field">
                    <label>Upload Images*</label>
                    <input
                      type="file"
                      name="images"
                      className="form-control"
                      multiple
                      onChange={handleFileChange}
                      required
                    />
                    <p>
                      <span>Supported formats: png, jpeg, jpg, webp</span>
                    </p>
                    <div className="file-preview text-center">
                      {previewImages.map((image, index) => (
                        <img key={index} src={image} alt={`preview ${index}`} />
                      ))}
                    </div>
                  </div>
                </div>
                  <div className="col-lg-12 col-md-12">
                    <div className="input-field">
                      <label>Blog Content*</label>
                      <ReactQuill
                        theme="snow"
                        name="content"
                        value={formValues.content}
                        onChange={(content) =>
                          setFormValues(prev => ({ ...prev, content }))
                        }
                        placeholder="Enter Blog Content"
                        required
                      />
                    </div>
                  </div>
                </div>
                <button className="site-btn-green" type="submit" >
                SUBMIT
                </button>
              </form>
              {errorMessage && <div className="error-message">{errorMessage}</div>}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddNew;
